import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ShoppingCart } from 'lucide-react';

const ProductCard = ({ product, onAddToCart }) => {
  const handleQuickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onAddToCart) {
      onAddToCart(product);
    }
  };

  return (
    <Link 
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block"
    >
      <div className="bg-white border-4 border-[#004D51] rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
        {/* Product Image */}
        <div className="relative aspect-square bg-gray-100 overflow-hidden">
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
          
          {/* Stock Badge */}
          {!product.inStock && (
            <div className="absolute top-4 right-4 bg-[#545759] text-white px-3 py-1 rounded-full text-xs font-bold">
              OUT OF STOCK
            </div>
          )}
          
          {/* Featured Badge */}
          {product.featured && product.inStock && (
            <div className="absolute top-4 right-4 bg-[#DB5A14] text-white px-3 py-1 rounded-full text-xs font-bold">
              BESTSELLER
            </div>
          )}
        </div>

        {/* Product Info */}
        <div className="p-6">
          <h3 className="text-xl font-black text-[#004D51] mb-2 group-hover:text-[#DB5A14] transition-colors">
            {product.name}
          </h3>
          
          <p className="text-sm text-[#545759] mb-4 line-clamp-2">
            {product.tagline}
          </p>

          {/* Price & Action */}
          <div className="flex items-center justify-between">
            <div className="text-2xl font-black text-[#004D51]">
              ${product.price.toFixed(2)} {product.currency}
            </div>
            
            {product.inStock && (
              <Button
                onClick={handleQuickAdd}
                className="bg-[#DB5A14] hover:bg-[#F39C49] text-white font-bold px-4 py-2 rounded-lg transition-all transform hover:scale-105"
              >
                <ShoppingCart className="w-4 h-4 mr-2" />
                Add
              </Button>
            )}
          </div>

          {/* Size Indicator */}
          {product.sizes && product.sizes.length > 0 && (
            <div className="mt-4 text-xs text-[#545759] font-medium">
              Sizes: {product.sizes.join(', ')}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;